import { Grid } from '@mui/material';
import NavList from './NavList';

const PrimaryNav = ({ data, styles }) => (
  <Grid
    item
    container
    spacing={2}
    wrap='wrap'
    justifyContent='space-between'
    sx={styles.containerGrid}
  >
    {data?.map((nav, i) => (
      <Grid key={i} item xs={12} md='auto' sx={styles.navGrid}>
        <NavList nav={nav} styles={styles.accordion} />
      </Grid>
    ))}
  </Grid>
);

export default PrimaryNav;
